<template>
    <div class="custom-control custom-checkbox">
        <input
            type="checkbox"
            :checked="checked"
            :name="name"
            :value="value"
            :class="['custom-control-input', {'is-invalid': errors(name)}]"
            :id="name"
            @change="$emit('change', $event.target.checked)"
        >
        <label :for="name" class="custom-control-label">
            <slot></slot>
        </label>
        <span class="invalid-feedback" v-if="errors(name)">
            <strong>{{ errors(name) }}</strong>
        </span>
    </div>
</template>
<script>
export default {
    model: {
        prop: 'checked',
        event: 'change'
    },

    props: {
        name: String,
        value: {
            type: String,
            default: "1"
        },
        checked: Boolean,
    },
}
</script>
